import React, { useEffect, useState, useRef } from 'react';
import styled, { css } from 'styled-components';
import Combobo from './combobo/dist'; // https://github.com/dequelabs/combobo
import countries from './data';
import { useSelector, useDispatch } from 'react-redux'
import { setValue } from 'zengenti-forms-package/redux/actions';
import { doA11yValidation } from 'zengenti-forms-package/utils/validate-utils';
import { makeSelectFormValidationSent } from 'zengenti-forms-package/redux/selectors';


const CountrySelect = ({ formId, id, label, field, validations, defaultValue = '', placeholder }) => {
  const elInputRef = useRef(null);
  const [country, setCountry] = useState(defaultValue);

  const selectFormValidationSent = makeSelectFormValidationSent(formId);
  const formValidationSent = useSelector(selectFormValidationSent);
  const [a11yInvalid, setA11yInvalid] = useState('');

  const isRequired = validations && validations.required ? true : false;

  useEffect(() => {
    if (formValidationSent) setA11yInvalid(doA11yValidation(country, field, true));
  }, [formValidationSent])

  const dispatch = useDispatch();
  const doUpdate = (value) => {
    setCountry(value);
    dispatch(setValue(formId, id, value));
    setA11yInvalid(doA11yValidation(value, field, formValidationSent));
  }

  const onKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      doUpdate(evt.target.value);
    }
  }

  useEffect(() => {
    if (elInputRef?.current) {
      const combo = new Combobo({
        input: elInputRef?.current,
        list: '.input__countries .input__listbox',
        noResultsText: 'No countries found.',
        onSelect: (value) => {
          doUpdate(value);
        },
        onKeyDown: (evt) => {
          if (evt.key === 'Escape') combo.close();
        }
      });

      elInputRef?.current?.addEventListener('keydown', onKeyDown);
      return () => {
        elInputRef?.current?.removeEventListener('keydown', onKeyDown);
        if (combo && typeof combo.destroy === 'function') combo.destroy();
      };
    }

  }, []);


  useEffect(() => {
    if (defaultValue) {
      setCountry(defaultValue);
      dispatch(setValue(formId, id, defaultValue));
    }
  }, [defaultValue])



  return (
    <CountrySelectStyled className='input__countries'>
      <label className='input__label' htmlFor="country-searchable-select">
        {label}
        {isRequired ? <span className='label__required'>(required)</span > : <span className='label__optional'>(optional)</span>}
      </label>
        <div className="input__wrapper">
        <input
            type="text"
            placeholder={placeholder}
            className="input"
            id="country-searchable-select"
            ref={elInputRef}
            aria-invalid={a11yInvalid}
            defaultValue={defaultValue}
        />
        {a11yInvalid == 'true' && (
          <svg className="svg" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" role="presentation" width="16" height="16" fill="none"><path fill="#333" d="M12.2 3.807a.664.664 0 0 0-.94 0L8 7.06 4.74 3.8a.665.665 0 0 0-.94.94L7.06 8 3.8 11.26a.664.664 0 1 0 .94.94L8 8.94l3.26 3.26a.665.665 0 0 0 .94-.94L8.94 8l3.26-3.26a.668.668 0 0 0 0-.933Z"/></svg>
        )}
        {a11yInvalid == 'false' && (
          <svg className="svg" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true" role="presentation" width="16" height="16" fill="none"><path fill="#333" d="m2 8 4.418 4.667L14 4.659l-1.246-1.326-6.336 6.692-3.18-3.332L2 8Z"/></svg>
        )}
        <ul className="input__listbox" aria-labelledby="List of countries">
          {countries.map((country, i) => (
            <li
              key={`${country.code}-${i}`}
              className="option"
              onClick={() => doUpdate(country.name)}
              aria-labelledby={country.name}
            >
              <span role="presentation" style={{ display: 'flex', alignItems: 'center' }}>
                <span>{country.name}{' '}<span aria-hidden="true">{country.flag}</span></span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </CountrySelectStyled>
  )
}

export default CountrySelect

const CountrySelectStyled = styled.div`
  ${() => {
  return css`
    display: flex;
    flex-direction: column;

    --semantic-type-1: #01010c;
    --semantic-background-1: #fff;
    --semantic-active-background-1: #efefef;
    --semantic-border-1: #949494;

    .input__label {
      margin-bottom: 4px;
    }

    .input__wrapper {
      position: relative;
    }

    .input__listbox {
      display: none;
      position: absolute;
      top: 40px; 
      left: 0;
      width: 100%;
      padding: 8px;
      background: var(--semantic-background-1);
      z-index: 99;
      text-align: left;
      overflow-y: auto;
      border: 1px solid var(--semantic-border-1);
      max-height: 400px;
    }

    .input__listbox.open {
      display: block;
    }

    .input__listbox .option {
      padding: 8px;
      cursor: default;
      display: flex;
      align-items: center;
      border: none;
      width: 100%;
    }

    .input__listbox .option.selected {
      color: var(--semantic-type-1);
      background-color: var(--semantic-active-background-1);
    }

    .input__listbox .option.active {
      color: var(--semantic-type-1);
      background-color: var(--semantic-active-background-1);
    }
    `;
  }};
`;
